module.exports = __webpack_public_path__ + "static/img/cont49 (6).1436715.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont49 (6).jpg
// module id = UrGq
// module chunks = 0